import type { BetSlipItem } from '@mobi/betslip/types'

export const updateItemsWithCampaignAndInvestment = (
  items: BetSlipItem[],
  updatedItems: BetSlipItem[]
): BetSlipItem[] =>
  items.map(item => {
    const updatedItem = updatedItems.find(updated => updated.id === item.id)

    if (updatedItem) {
      item.campaign = updatedItem.campaign

      if (updatedItem.investment?.bonusBet) {
        item.investment = {
          ...item.investment,
          bonusBet: updatedItem.investment.bonusBet,
        }
      }
    }

    return item
  })
